import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

function Navigation() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn'); // if you're using a login flag
    // clear any other auth info as needed
    navigate('/'); // redirect to login page
  };

  return (
    <nav style={{ padding: '10px 20px', background: '#eee' }}>
      {/* <Link to="/" style={{ marginRight: '15px' }}>Auth</Link> */}
      <Link to="/home" style={{ marginRight: '15px' }}>Home</Link>
      <Link to="/admin" style={{ marginRight: '15px' }}>Admin</Link>
      <Link to="/portal" style={{ marginRight: '15px' }}>Portal</Link>
      <button onClick={handleLogout} style={{ marginLeft: '20px', float: 'right' }}>Logout</button>
    </nav>
  );
}

export default Navigation;
